import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Appends query parameters to a URL, handling existing params and encoding.
 * @param url The base URL
 * @param params An object of key-value pairs to append as query params
 * @returns The URL with the new query params appended
 */
export function appendQueryParams(
  url: string,
  params: Record<string, string | undefined | null>
): string {
  const [base, query = ''] = url.split('?');
  const urlParams = new URLSearchParams(query);
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      urlParams.set(key, value);
    }
  });
  const queryString = urlParams.toString();
  return queryString ? `${base}?${queryString}` : base;
}
